export const PowerBtn = (props) => {
    return (
      <svg
        aria-hidden="true"
        data-prefix="fas"
        data-icon="power-off"
        className="prefix__svg-inline--fa prefix__fa-power-off prefix__fa-w-16"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        {...props}
      >
        <path
          fill={props.fill}
          d="M400 54.1c63 45 104 118.6 104 201.9 0 136.8-110.8 247.7-247.5 248C120 504.3 8.2 393 8 256.4 7.9 173.1 48.9 99.3 111.8 54.2c11.7-8.3 28-4.8 35 7.7L162.6 90c5.9 10.5 3.1 23.8-6.6 31-41.5 30.8-68 79.6-68 134.9-.1 92.3 74.5 168.1 168 168.1 91.6 0 168.6-74.2 168-169.1-.3-51.8-24.7-101.8-68.1-134-9.7-7.2-12.4-20.5-6.5-30.9l15.8-28.1c7-12.4 23.2-16.1 34.8-7.8zM296 264V24c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24v240c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24z"
        />
      </svg>
    )
  }
  
  export const Github = (props) => {
      return (
          <svg
            aria-hidden="true"
            data-prefix="fab"
            data-icon="github"
            className="prefix__svg-inline--fa prefix__fa-github prefix__fa-w-16"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 496 512"
            {...props}
          >
            <path
              fill={props.fill}
              d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
            />
          </svg>
        )
  }
  
  export const Twitter = (props) => {
      return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width={600}
        height={636}
        viewBox="0 0 1200 1227"
        {...props}
      >
        <path d="M2 1.4c0 .3 104.9 153.2 233.1 339.8C363.4 527.8 468.3 681 468.4 681.6c.1.5-104.7 122.9-232.9 271.8-128.2 149-233.2 271.3-233.3 271.7-.2.5 22.3.8 51.6.7l52.1-.3L310.2 988C422.6 857.4 515 750.6 515.5 750.6c.6 0 74.4 106.9 164.1 237.5l163.2 237.4 177.7.3c150.1.2 177.6 0 177.2-1.2-.3-.7-109.3-159.6-242.2-353-132.9-193.5-241.4-352.3-241.2-352.9.4-.9 430.9-501.7 443.5-516 1.4-1.6-1.1-1.7-50.9-1.6h-52.4l-193.4 225C754.8 349.8 667.5 451 667.1 451c-.3 0-70.1-101.2-155.1-225L357.5 1.1 179.8 1C82 1 2 1.2 2 1.4zm678.7 612.3c205.6 294 374.2 535.2 374.6 536 .7 1.1-13 1.3-81.1 1.3h-81.9L734.8 925.7C648.2 801.9 480.4 561.9 362 392.5 243.6 223.1 145.9 83.3 144.8 81.7l-1.9-2.7h163.9l373.9 534.7z" />
      </svg>
        )
  }
  
  export const Instagram = (props) => {
      return (
        <svg
    xmlns="http://www.w3.org/2000/svg"
    width={800}
    height={800}
    viewBox="0 0 256 256"
    {...props}
  >
    <path d="M160 128a32 32 0 1 1-32-32 32.037 32.037 0 0 1 32 32Zm68-44v88a56.064 56.064 0 0 1-56 56H84a56.064 56.064 0 0 1-56-56V84a56.064 56.064 0 0 1 56-56h88a56.064 56.064 0 0 1 56 56Zm-52 44a48 48 0 1 0-48 48 48.054 48.054 0 0 0 48-48Zm16-52a12 12 0 1 0-12 12 12 12 0 0 0 12-12Z" />
  </svg>
        )
  }
  
  export const YouTube = (props) => {
      return (
          <svg
            aria-hidden="true"
            data-prefix="fab"
            data-icon="youtube"
            className="prefix__svg-inline--fa prefix__fa-youtube prefix__fa-w-18"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 576 512"
            {...props}
          >
            <path
              fill={props.fill}
              d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"
            />
          </svg>
        )
  }
  
  export const YinYang = (props) => {
      return (
        <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1200}
    height={1200}
    viewBox="0 0 900 900"
    {...props}
  >
    <path d="M419.5 1.1C294.2 9.4 177.4 70.7 98.6 169.4-1.8 295-27.4 465.3 31.7 615 87.3 755.9 211.4 860.4 359 890.5c32.2 6.6 56.7 8.9 92.5 8.9 40.3-.1 70.7-3.8 107.5-13C676 857.1 776 782.7 837.5 679c54.5-91.8 74.3-202.5 55.5-309-16.1-90.6-61.9-177-128.2-241.6C672.6 38.5 547.9-7.5 419.5 1.1zm61 17.9c134 9.6 254.3 79.7 329.1 191.6 6.3 9.3 11.4 17.3 11.4 17.7 0 .4-6.4.7-14.3.7-24.1 0-56.4 4.8-101.3 15.2l-22.2 5.1-22.3-22.5c-22.6-22.7-36.9-35.3-57.9-50.9-86.7-64.6-178.8-91.5-266.7-78-68.2 10.5-139.1 38.3-190.3 74.5-30.2 21.5-60.7 51.9-76.9 76.9-8.6 13.3-5.6 6.6 6.6-14.6 52-90.8 138.1-161.3 237-194.3 34.7-11.6 75.7-19.7 110.3-21.7 13.2-.8 44.6-.6 57.5.3zm4.9 156.1c31.7 4.5 65.4 16.1 95 32.6 21.8 12.1 46.2 29.6 62 44.3l6.8 6.4-6.9 1.8c-30.1 8.1-93.8 27.9-132.8 41.2l-22 7.5L370 285.4c-64.6-12.9-118.4-23.8-119.4-24.3-1.7-.6-.4-2.1 8.7-9.9 25.3-21.7 48.3-37 76.2-50.8 34-16.7 62-24.4 101.5-27.8 9.1-.8 34.9.6 48.4 2.5zm357.8 95.4c15.1 32.8 27.4 73.3 33.3 109.5 8.1 49.6 7.2 104.2-2.5 153.4-16.6 84.2-57.3 160.6-118 221.5-62.3 62.6-143.8 105.1-230.5 120.4-14.9 2.7-37.2 5.3-38 4.6-.2-.3 1.3-3.9 3.4-8 5.8-11.1 14.4-33.5 20.2-52.5 4.2-14.1 14.4-53.3 17.6-67.8l.8-4 15.5-3.8c107.3-26.5 190.5-80 239.8-154.2 31.9-48.1 57.6-125.3 64.3-193.1 1.6-15.7 1.6-54 0-68.5-1.6-15.8-4.7-33.3-8.1-47-3-11.9-10-33.2-12.6-38.1-.8-1.5-1.4-3.2-1.4-3.6.1-1.3 10.7 19.3 16.2 31.2zm-778.5 4.8c13.3 21.1 49.4 60.3 84.7 91.9l3.9 3.5-3.6 13.9c-6.8 26.1-11.3 51.4-14.9 82.9-2 17.4-1.7 72.7.5 90.5 8.5 69.5 33.4 128.3 74.4 175.7 64.6 74.8 140.9 123.9 219.3 141.2 12.1 2.7 28.1 5.1 34.5 5.2 2.8 0 5.9.5 7 1 3.1 1.5-50 .2-65.9-1.5-109-12.1-207.1-63-278.9-144.6-59.5-67.7-95.1-149.3-105.4-241.2-2-18.6-2.3-65.3-.4-83.3 4.9-48.1 15.8-90.4 34.2-133.2 2.4-5.7 4.6-10.3 4.9-10.3.3 0 2.8 3.7 5.7 8.3zm405 68.2c48 9.1 84.3 49.1 88.1 97 3.6 46.1-20.7 88.1-62.4 107.6-33 15.5-74.2 12.5-104.7-7.8-40.8-27.1-58.5-78-43.1-124.2 5.7-17.3 13.2-29.3 26.7-42.9 15.2-15.5 36.6-26.5 58.6-30.2 8.1-1.4 28.5-1.1 36.8.5zm251.9 57.7c6.3 50.8 2.2 101.4-11.7 143.3-12.7 38.2-33.9 71.9-63.2 100.1-20.9 20.2-42.2 35.2-70.2 49.4-13 6.6-38.4 17.5-39.1 16.8-.1-.2.9-5.9 2.2-12.8 6-31 16.1-93.3 21.5-133l2.1-15.5 11.6-12c6.4-6.6 21.2-21.7 32.7-33.5 11.6-11.8 30.1-30.7 41.1-42s29.5-30.2 41.1-42c11.6-11.8 23.1-23.6 25.4-26.2 2.3-2.7 4.4-4.6 4.7-4.4.2.3 1 5.6 1.8 11.8zm-523.1 9.3c28.1 23.9 84.7 69.5 104.1 83.9l5 3.8 8.4 23.1c4.5 12.8 11.1 31.1 14.6 40.7 3.4 9.6 14.4 40.2 24.4 68 10 27.8 21.2 59 25 69.5 3.8 10.4 6.7 19.1 6.5 19.3-1.1 1.1-35.2-12.2-52.2-20.3-33.9-16.2-58.4-32.9-82.2-56-42.3-41.1-66.5-90.8-74.8-153.4-3-23.1-2.2-64.3 1.9-87.9.9-5.7 1.2-6.2 2.7-4.9.9.8 8.4 7.1 16.6 14.2z" />
  </svg>
        )
  }
  
  
  
  
  export const Link = (props) => {
    return (
      <svg
        aria-hidden="true"
        data-prefix="fas"
        data-icon="link"
        className="prefix__svg-inline--fa prefix__fa-link prefix__fa-w-16"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        {...props}
        
      >
        <path
          fill={props.fill}
          
          d="M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 01-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0120.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0020.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 00-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"
        />
      </svg>
    )
  }
  
  
  
  export const Design = (props) => { 
    return (
      <svg
        aria-hidden="true"
        data-prefix="fas"
        data-icon="palette"
        className="prefix__svg-inline--fa prefix__fa-palette prefix__fa-w-16"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        {...props}
      >
        <path
          fill={props.fill}
          d="M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
        />
      </svg>
    )
  
  }
  
  export const Develope = (props) => { 
    return (
      <svg
        aria-hidden="true"
        data-prefix="fas"
        data-icon="laptop-code"
        className="prefix__svg-inline--fa prefix__fa-laptop-code prefix__fa-w-20"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 512"
        {...props}
      >
        <path
           fill={props.fill}
          d="M255.03 261.65c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31c6.25-6.25 6.25-16.38 0-22.63L253.25 192l35.71-35.72c6.25-6.25 6.25-16.38 0-22.63l-11.31-11.31c-6.25-6.25-16.38-6.25-22.63 0l-58.34 58.34c-6.25 6.25-6.25 16.38 0 22.63l58.35 58.34zm96.01-11.3l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l58.34-58.34c6.25-6.25 6.25-16.38 0-22.63l-58.34-58.34c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63L386.75 192l-35.71 35.72c-6.25 6.25-6.25 16.38 0 22.63zM624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"
        />
      </svg>
    )
  
  }